module.exports = __webpack_public_path__ + "static/media/abc-news.054ab9e8.jpg";